import { TeamMapper } from "../team/team.mapper";

import { User } from "./user.model";
import { GroupMapper } from "./group/group.mapper";
import { CompanyMapper } from "app/company/company.mapper";

export class UserMapper {
  public static map(userData: any): User {
    return new User(
      +userData.id,
      userData.username,
      userData.email,
      null,
      userData.lastLogin,
      userData.activeAt,
      userData.roles,
      userData.groups && userData.groups.length
        ? userData.groups.map(GroupMapper.map)
        : [],
      userData.firstName,
      userData.lastName,
      userData.team ? TeamMapper.map(userData.team) : null,
      userData.company ? CompanyMapper.map(userData.company) : null,
      userData.phone,
      userData.ref,
      userData.signature,
      userData.enabled,
      userData.limitedCrm,
      userData.language,
      userData.mailIntegrationEnabled,
      userData.mailUsername,
      userData.mailPassword,
      userData.mailImapPath,
      userData.mailMsGraphFolder,
      userData.emailIntegrationType,
      userData.lastQuoteType,
      userData.modules,
      userData.hasCompanies,
      userData.emailIntegrationConnected,
    );
  }
}
